import { formatAcres } from "./acreageFormatting.js";

function formatUpdatedAt(value) {
  if (!value) {
    return "";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }

  return parsed.toLocaleString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

function buildFieldContextQuickFacts({ farm, field, auditRecord = field }) {
  const fieldSize = formatAcres(field?.field_size);

  return [
    { label: "Farm", value: farm?.name || "" },
    {
      label: "Field Size",
      value: fieldSize ? `${fieldSize} Acres` : "",
    },
    { label: "Address", value: field?.field_address || "" },
    { label: "Last Updated", value: formatUpdatedAt(auditRecord?.updated_at) },
    {
      label: "Last Updated By",
      value: auditRecord?.updated_by || auditRecord?.created_by || "",
    },
  ];
}

export { buildFieldContextQuickFacts, formatUpdatedAt };
